module.exports = __webpack_public_path__ + "img/yzsbot.09c2fb20.png";